import apiClient from './apiClient';

export interface WeeklyReportStats {
  apkScanCount: number;
  malwareDetected: number;
  smsScanCount: number;
  phishingSmsDetected: number;
  voicephishingBlocked: number;
  spamBlocked: number;
}

export interface TopThreat {
  type: string;
  label: string;
  count: number;
  changeRate: number;
  topExample: string;
}

export interface WeeklyReport {
  _id: string;
  weekStartDate: string;
  weekEndDate: string;
  status: 'generating' | 'ready' | 'notifying' | 'completed' | 'failed';
  stats: WeeklyReportStats;
  prevWeekStats: WeeklyReportStats;
  topThreats: TopThreat[];
  summary: string;
  notifiedCount: number;
  failedCount: number;
  retryCount: number;
  shareCount: number;
  generatedAt: string;
  createdAt: string;
}

export interface WeeklyReportListResponse {
  reports: WeeklyReport[];
  stats: {
    total: number;
    completed: number;
    failed: number;
    totalNotified: number;
    totalFailed: number;
  };
}

export const getAdminWeeklyReports = async (): Promise<WeeklyReportListResponse> => {
  const res = await apiClient.get('/admin/reports/weekly');
  return res.data.data;
};

export const generateWeeklyReport = async (weekStartDate?: string): Promise<WeeklyReport | null> => {
  const res = await apiClient.post('/admin/reports/weekly/generate', { weekStartDate });
  return res.data.data ?? null;
};

export const resendWeeklyReport = async (id: string): Promise<{ notifiedCount: number; failedCount: number }> => {
  const res = await apiClient.post(`/admin/reports/weekly/${id}/notify`);
  return res.data.data;
};

export const updateWeeklyReportStats = async (
  id: string,
  stats: Partial<WeeklyReportStats>,
  summary?: string,
): Promise<WeeklyReport> => {
  const res = await apiClient.put(`/admin/reports/weekly/${id}/stats`, { stats, summary });
  return res.data.data;
};

export const deleteWeeklyReport = async (id: string): Promise<void> => {
  await apiClient.delete(`/admin/reports/weekly/${id}`);
};
